import Selo  from "@/entities/Selo/Selo"

class SeloItemOs {
  constructor (data) {
    this.selo_item_os_id = null
    this.ordem_servico_item_id = null
    this.selo_id = null
    this.created_at = null
    this.updated_at = null   

    if (data) this.__init(data)
  }

  __init (data) {
    Object.assign(this, data)
    if (data.selo) {
      this.selo = new Selo(data.selo)
    }
  }
}

export default SeloItemOs